export const STICK_THRESHOLD_PX = 48;

/**
 * Whether a scroll container is within `thresholdPx` of the bottom — i.e. the user is parked at
 * the bottom, so a streaming reply should keep auto-scrolling into view. When they've scrolled up
 * to read earlier messages this is false, so auto-scroll backs off and doesn't yank them down.
 */
export function isNearBottom(
  { scrollHeight, scrollTop, clientHeight }: Pick<HTMLElement, "scrollHeight" | "scrollTop" | "clientHeight">,
  thresholdPx: number = STICK_THRESHOLD_PX,
): boolean {
  return scrollHeight - scrollTop - clientHeight < thresholdPx;
}
